// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__QWcKi","flex-container":"sidebar_flex-container__f8fhD"};